<template>
  <section class="screen-main">
    <div class="screen-main-container">
      <keep-alive>
        <router-view v-if="keepAlive" :key="key" />
      </keep-alive>
      <router-view v-if="!keepAlive" :key="key" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'ScreenMain',
  computed: {
    key() {
      return this.$route.path
    },
    keepAlive() {
      return !!this.$route.meta.keepAlive
    }
  }
}
</script>

<style lang="scss" scoped>
.screen-main {
  /* 50= navbar  50  */
  min-height: 100%;
  width: 100%;
  position: relative;
  background: rgba(241, 242, 243, 0.5);
  .screen-main-container {
    background: #fff;
  }
}
</style>
